/** Inline SVG fragment IDs are document-wide; preserve item identity markers. */
export function scopeSvgIds(svg: string, namespace: string): string {
  const ids = new Map([...svg.matchAll(/\sid=(["'])([^"']+)\1/g)]
    .map((match) => [match[2], `${namespace}-${match[2]}`]));
  if (ids.size === 0) return svg;
  return svg
    .replace(/(\s)id=(["'])([^"']+)\2/g,
      (_match, space: string, quote: string, id: string) => `${space}id=${quote}${ids.get(id)}${quote}`)
    .replace(/url\(\s*(["']?)#([^\s)"']+)\1\s*\)/g,
      (match, quote: string, id: string) => ids.has(id) ? `url(${quote}#${ids.get(id)}${quote})` : match)
    .replace(/(\s(?:xlink:)?href=)(["'])#([^"']+)\2/g,
      (match, attribute: string, quote: string, id: string) => ids.has(id)
        ? `${attribute}${quote}#${ids.get(id)}${quote}` : match);
}

/** Match the game's SVG renderer bounds without allowing invalid layout sizes. */
export function normalizePortraitSize(size = 200): number {
  return Number.isFinite(size) ? Math.max(16, Math.min(1024, Math.round(size))) : 200;
}

/** The labelled React wrapper owns accessibility and dimensions. */
export function preparePortraitSvg(svg: string, namespace: string): string {
  return scopeSvgIds(svg.replace(/^<svg width="[^"]+" height="[^"]+"/,
    '<svg aria-hidden="true" focusable="false" width="100%" height="100%"'), namespace);
}
